import _ from 'lodash';
import * as types from '../mutation-types';
import funders from '../../api/funders';
import users from '@/api/user';

const state = {
  funders: {
    Loading: [
      {
        provider: { id: null },
        type: { name: null },
        journey: { name: null }
      }
    ]
  },
  currentPage: 1,
  pageSize: 1000,
  lastPage: 1,
  total: null,
  orderby: 'provider.name.raw',
  orderDirection: 'asc',
  search: '',
  includeDisabled: false,
  journeyFilter: null,
  selected: {
    logo: null,
    colours: {},
    provider: {
      users: [
        {
          id: null
        }
      ]
    },
    fee_tiers: []
  },
  selectedUser: {
    full_name: null
  },
  apiProperties: [
    {
      key: null,
      value: null
    }
  ],
  selectedFunderEnquiryTab: {
    Active: {
      selected: true,
      stale: false
    },
    Funded: {
      selected: false,
      stale: false
    },
    Inactive: {
      selected: false,
      stale: false
    }
  }
};

const getters = {
  FundersList: state => state.funders,
  FunderSearch: state => state.search,
  FunderJourneyFilter: state => state.journeyFilter,
  FunderIncludeDisabled: state => state.includeDisabled,
  SelectedFunder: state => state.selected,
  SelectedFunderUser: state => state.selectedUser,
  apiProperties: state => state.apiProperties,
  SelectedFunderEnquiryTab: state => state.selectedFunderEnquiryTab
};

const actions = {
  getFundersList({ commit, dispatch, rootState }, customerId = '') {
    commit(types.SET_FUNDER_CURRENT_PAGE, 1);
    commit(types.RESET_FUNDER_TOTAL);
    return new Promise((resolve, reject) => {
      const page = state.currentPage;
      const orderby = [{ [state.orderby]: state.orderDirection }];
      const search = _.isNull(state.search) ? '*' : state.search;
      const fields = ['id', 'name', 'enabled', 'provider.name', 'type.name', 'journey.name'];
      const terms = {};
      if (state.includeDisabled !== true) {
        terms['enabled'] = [true];
      }
      if (rootState.user.roles.includes('Provider')) {
        terms['provider.id'] = rootState.user.businesses;
      }
      if (state.journeyFilter !== null) {
        terms['journey.id'] = [state.journeyFilter];
      }

      funders
        .getFundersList(page, state.pageSize, orderby, search, terms, fields)
        .then(response => {
          if (response.total > 0) {
            const funders = _.map(response.hits, '_source');
            const fundersList = _.groupBy(funders, funder => funder.provider.name);
            commit(types.SET_FUNDERS_LIST, fundersList);
            dispatch('selectFunder', { id: funders[0].id, customerId });
          }
        })
        .catch(error => {
          console.log(error);
          reject(error.data);
        });
    });
  },

  selectFunder({ commit, dispatch, state }, { id, customerId = '' }) {
    funders.getFunder(id).then(funder => {
      commit(types.SET_SELECTED_FUNDER, funder._source);
      const enquiryState = _.findKey(state.selectedFunderEnquiryTab, function(tab) {
        return tab.selected === true;
      });
      const tabUpdate = {
        Active: {
          stale: enquiryState !== 'Active'
        },
        Funded: {
          stale: enquiryState !== 'Funded'
        },
        Inactive: {
          stale: enquiryState !== 'Inactive'
        }
      };
      commit(types.SET_SELECTED_FUNDER_ENQUIRY_TAB, tabUpdate);
      dispatch('getFunderEnquiries', { append: false, enquiryState, customerId: customerId });
      dispatch('selectFunderUser', funder._source.provider.users[0]);
    });
  },
  updateFunder({ commit, dispatch }, { id, updates }) {
    funders.update(id, updates).then(response => {
      dispatch('addNotification', {
        text: 'Product details have been updated',
        bottom: true,
        left: true,
        colour: 'success'
      });
      commit(types.SET_SELECTED_FUNDER, response.data);
    });
  },
  updateFunderBusiness({ dispatch }, { id, updates }) {
    funders.updateBusiness(id, updates).then(() => {
      dispatch('addNotification', {
        text: 'Funder details have been updated',
        bottom: true,
        left: true,
        colour: 'success'
      });
    });
  },
  registerFunder({ dispatch }, funder) {
    return new Promise((resolve, reject) => {
      funders
        .register(funder, false)
        .then(() => {
          dispatch('getFundersList');
          resolve();
        })
        .catch(error => reject(error));
    });
  },
  updateFunderUser({ commit, dispatch, state }, { id, updates }) {
    users.updateUser(id, updates).then(() => {
      dispatch('addNotification', {
        text: 'Product user details have been updated',
        bottom: true,
        left: true,
        colour: 'success'
      });
      funders.getFunder(state.selected.id).then(funder => commit(types.SET_SELECTED_FUNDER, funder._source));
    });
  },
  sendFunderWelcomeMessage({ commit, dispatch, state }, id) {
    users.sendWelcomeMessage(id).then(() => {
      dispatch('addNotification', {
        text: 'Password reset and welcome message sent',
        bottom: true,
        left: true,
        colour: 'success'
      });
      funders.getFunder(state.selected.id).then(funder => commit(types.SET_SELECTED_FUNDER, funder._source));
    });
  },
  updateColour({ commit }, { id, colour }) {
    commit(types.UPDATE_COLOUR, { id, colour });
    funders.updateColour(id, colour);
  },
  selectFunderUser({ commit }, user) {
    commit(types.SELECT_FUNDER_USER, user);
    const update = {
      Active: {
        selected: true
      }
    };
    commit(types.SET_SELECTED_FUNDER_ENQUIRY_TAB, update);
  },
  setFunderSearch({ commit }, search) {
    commit(types.SET_FUNDER_SEARCH, search);
  },
  setFunderJourneyFilter({ commit }, journeyId) {
    commit(types.SET_FUNDER_JOURNEY_FILTER, journeyId);
  },
  unsetFunderJourneyFilter({ commit }) {
    commit(types.SET_FUNDER_JOURNEY_FILTER, null);
  },
  showDisabled({ commit }, include) {
    commit(types.SET_FUNDER_INCLUDE_DISABLED, include);
  },
  setApiProperties({ commit }, properties) {
    commit(types.SET_FUNDER_API_PROPERTIES, properties);
  },
  addApiProperty({ commit }, property) {
    commit(types.ADD_FUNDER_API_PROPERTIES, property);
  },
  removeApiProperty({ commit }, property) {
    commit(types.REMOVE_FUNDER_API_PROPERTIES, property);
  },
  addFunderAPI({ dispatch }, updates) {
    funders.addAPI(updates).then(() => {
      dispatch('addNotification', {
        text: 'API details have been added',
        bottom: true,
        left: true,
        colour: 'success'
      });
    });
  },
  updateFunderAPI({ dispatch }, { id, updates }) {
    funders.updateAPI(id, updates).then(() => {
      dispatch('addNotification', {
        text: 'API details have been updated',
        bottom: true,
        left: true,
        colour: 'success'
      });
    });
  },
  setSelectedFunderEnquiryTab({ commit }, update) {
    commit(types.SET_SELECTED_FUNDER_ENQUIRY_TAB, update);
  }
};

const mutations = {
  [types.SET_FUNDER_CURRENT_PAGE](state, page) {
    state.currentPage = page;
  },
  [types.RESET_FUNDER_TOTAL](state) {
    state.total = null;
  },
  [types.SET_FUNDERS_LIST](state, funders) {
    state.funders = funders;
  },
  [types.SET_SELECTED_FUNDER](state, response) {
    state.selected = response;
  },
  [types.SET_SELECTED_FUNDER_IN_LIST](state, response) {
    let name = response.provider.name;
    let id = response.id;
    let index = _.findIndex(state.funders[name], { id });
    state.funders[name][index] = response;
  },
  [types.SELECT_FUNDER_USER](state, user) {
    state.selectedUser = user;
  },
  [types.UPDATE_COLOUR](state, { id, colour }) {
    let index = _.findIndex(state.selected.colours, { id });
    state.selected.colours[index].colour = colour;
  },
  [types.SET_FUNDER_SEARCH](state, search) {
    state.search = search;
  },
  [types.SET_FUNDER_JOURNEY_FILTER](state, journeyId) {
    state.journeyFilter = journeyId;
  },
  [types.SET_FUNDER_INCLUDE_DISABLED](state, include) {
    state.includeDisabled = include;
  },
  [types.SET_FUNDER_API_PROPERTIES](state, properties) {
    state.apiProperties = properties;
  },
  [types.ADD_FUNDER_API_PROPERTIES](state, property) {
    state.apiProperties.push(property);
  },
  [types.REMOVE_FUNDER_API_PROPERTIES](state, property) {
    _.remove(state.apiProperties, { key: property.key });
  },
  [types.SET_SELECTED_FUNDER_ENQUIRY_TAB](state, update) {
    _.merge(state.selectedFunderEnquiryTab, update);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
